module.exports = __webpack_public_path__ + "img/index08.7b1598e0.png";